<template>
  <div class="cesiumBox" id="cesiumBox">
    <div class="bg" v-show="isView"></div>
    <!-- 三维盒子 -->
    <div id="cesiumContainer" @mouseover="typeBoxFlag = null"></div>
    <!-- 页面功能元素盒子 头部按钮导航-->
    <div class=" heade">
      <!--子元素盒子 定位-->
      <div class="header-children">
        <!-- 左侧功能 -->
        <div class="animate__animated animate__slideInLeft leftFunction">
          <!-- 显示隐藏页面元素 -->
          <div class="animate__animated animate__flash explicitAndImplicit">
            <a-icon type="double-right" @click="explicitAndImplicitFlag = false" v-if="explicitAndImplicitFlag" />
            <a-icon type="double-left" @click="explicitAndImplicitFlag = true" v-else />
          </div>
          <!-- 搜索框 -->
          <div class="searchBox" style="width:50%">
            <a-input-search v-model="searchValue" placeholder="请输入目标名称或国际编号" class=" search" />
          </div>
          <!-- <div class="searchBox" :class="[
                        explicitAndImplicitFlag
                            ? 'animate__animated animate__fadeOutLeft'
                            : 'animate__animated animate__fadeInLeft',
                    ]">
            <el-select v-model="region" clearable filterable placeholder="国家/地区">
              <el-option v-for="item in countriesOption" :key="item.code" :label="item.chineseName" :value="item.code">
              </el-option>
            </el-select>
          </div> -->
          <div class="searchBox" :class="[
                        explicitAndImplicitFlag
                            ? 'animate__animated animate__fadeOutLeft'
                            : 'animate__animated animate__fadeInLeft',
                    ]">
            <el-select v-model="orbitType" clearable filterable placeholder="轨道类型">
              <el-option v-for="item in setiliteOption" :key="item.code" :label="item.chineseName" :value="item.code">
              </el-option>
            </el-select>
          </div>
          <!-- icon图标功能 -->
          <ul class="icons">
            <!-- <li :class="{ active: typeBoxFlag == 1 }" @mouseover="showBox(1)">
              <a-icon type="unordered-list" />
            </li> -->
            <li>
              <el-popover placement="bottom" :width="200" :visible="visible">
                <div class="logo"></div>
                <ul class="textInfo">
                  <li class="userInfo">
                    技术服务：<span>18618140606</span>
                  </li>
                  <li class="userInfo">
                    商务服务：<span>13911062683</span>
                  </li>
                  <li class="userInfo">
                    售后服务：<span>13011119560</span>
                  </li>
                </ul>
                <template #reference>
                  <el-button class="circleimgbut" circle @click="handVisible"><img style="width:100%" class="circleimg" src="../assets/star.png" alt=""></el-button>
                </template>
              </el-popover>
            </li>
            <!-- <li class="animate__animated animate__fadeInUp" @click="typeBoxFlag = 3"
                            :class="{ active: typeBoxFlag == 3 }" @mouseover="showBox(3)">
                            <a-icon type="home" @click.stop="camreaPosition" />
                        </li>
                        <li class="animate__animated animate__fadeInDown" :class="{ active: typeBoxFlag == 4 }"
                            @mouseover="showBox(4)">
                            <a-icon type="global" />
                        </li> -->
          </ul>
        </div>
        <!-- 右侧log盒子 -->
        <div class="animate__animated animate__slideInRight rightlog">
          <!-- 系统名称 -->
          <div class="logText">ADS - Data 太空编目数据</div>
          <!-- 分隔符 -->
          <div class="logLine"></div>
          <!-- log -->
          <div class="logBox"></div>
        </div>
      </div>
    </div>
    <!-- 搜索框目标集合 -->
    <div class="targetList" v-show="searchInfoFlag" :class="[
            searchInfoFlag
                ? 'animate__animated animate__slideInLeft'
                : 'animate__animated animate__fadeOutLeft',
        ]">
      <ul class="listBox" v-if="!searchLoadingFlag">
        <li v-for="(item, index) in filPersons" :key="index" @click="nweBreakCarame(item)">
          {{ item.objectName }} -- {{item.norad_cat_id}}
        </li>
      </ul>
      <div class="searchLoading" v-else>
        <div class="searchLoadingBox">
          <div class="loadEffect">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 目标类型集合 -->
    <div class="typeBox" v-show="typeBoxFlag == 1" @mouseleave="typeBoxFlag = null">
      <div class="typeChildBox">
        <ul class="typeChildBoxContent">
          <!-- <li>
                        <div class="leftText"> 空间目标总计：<span class="leftNum">{{  titleNum  }}</span></div>
                    </li> -->
          <li v-for="(item, index) in typeList" :key="index" :class="{ typeChildActive: typeChildActive == item.srcUrl }" @click="handelChild(item)">
            <div class="leftText">{{ item.name }} </div>
            <!-- <span class="leftNum">{{  item.Num  }}</span> -->
            <div class="iconBox">
              <!-- <a-switch v-model="item.switchFlag">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch> -->
              <div class="colorActive" v-if="item.srcUrl == 1" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
              <div class="colorActive" v-else-if="item.srcUrl == 2" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
              <div class="colorActive" v-else-if="item.srcUrl == 3" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
              <div class="colorActive" v-else-if="item.srcUrl == 4" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
              <div class="colorActive" v-else-if="item.srcUrl == 5" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
              <!--                             
                            <img v-if="item.srcUrl == 1" src="../assets/green.png" alt="" />
                            <img v-else-if="item.srcUrl == 2" src="../assets/red.png" alt="" />
                            <img v-else-if="item.srcUrl == 3" src="../assets/blue.png" alt="" />
                            <img v-else-if="item.srcUrl == 4" src="../assets/testGrey.png" alt="" />
                            <img v-else-if="item.srcUrl == 5" src="../assets/orange.png" alt="" /> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 功能集合 -->
    <div class="typeBox functionBox" v-show="typeBoxFlag == 2" @mouseleave="typeBoxFlag = null">
      <div class="typeChildBox">
        <ul class="typeChildBoxContent">
          <li v-for="(item, index) in functionList" :key="index" @click="handleFunction(item)">
            <div class="leftText">{{ item.name }}</div>
            <div class="iconBox">
              <a-switch v-model="item.switchFlag">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 视角集合 -->
    <div class="typeBox perspectiveSet" v-show="typeBoxFlag == 4" @mouseleave="typeBoxFlag = null">
      <div class="typeChildBox">
        <ul class="typeChildBoxContent">
          <li v-for="(item, index) in perspectiveSetList" :key="index">
            <div class="leftText">{{ item.name }}</div>
            <div class="iconBox">
              <a-switch v-model="item.switchFlag" @click="handlePerspective(item)">
                <a-icon slot="checkedChildren" type="check" />
                <a-icon slot="unCheckedChildren" type="close" />
              </a-switch>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 快速播放器 -->
    <div class="player">
      <div class="playerContainer">
        <p class="multiple">{{ sliderValue }} X</p>
        <div class="sliderBox">
          <el-slider v-model="sliderValue" :max="6848" :show-tooltip="false" :min="0" @change="sliderChange">
          </el-slider>
        </div>
        <p class="currentTime">UTC &nbsp;{{ currentTimeValue }}</p>
        <div class="handleChnageBox">
          <div class="slow" @click.stop="iconChnge('left')">
            <i class="el-icon-d-arrow-left"></i>
          </div>
          <div class="stop" @click.stop="iconChnge('center')">
            <i class="el-icon-video-pause" v-if="stopFlag"></i>
            <i class="el-icon-video-play" v-else></i>
          </div>
          <div class="fast" @click.stop="iconChnge('right')">
            <i class="el-icon-d-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 时间轴 -->
    <div class="timeLine" :class="{ activeTop: !menuFlag }" v-if="timeLineFlag">
      <!-- <ul class="tableNum">
        <li class="liNum" v-for="(item, index) in typeList" :key="index">
          <div class="colorActive" v-if="item.srcUrl == 1" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
          <div class="colorActive" v-else-if="item.srcUrl == 2" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
          <div class="colorActive" v-else-if="item.srcUrl == 3" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
          <div class="colorActive" v-else-if="item.srcUrl == 4" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
          <div class="colorActive" v-else-if="item.srcUrl == 5" :style="{ 'background': item.background, 'box-shadow': item.boxShadow }"></div>
          {{ item.name }}-{{ item.Num }}
        </li>
      </ul> -->
      <div class="time_child">
        <div class="menuBox">
          <template v-if="menuFlag">
            <div class="meunChildBox" @click.stop="displayHide(false)">
              <i class="el-icon-arrow-up arrow-up1" :style="{ color: colorFlag % 2 == 1 ? 'red' : '#fff' }"></i>
              <i class="el-icon-arrow-up arrow-up2" :style="{ color: colorFlag % 2 == 1 ? 'red' : '#fff' }"></i>
            </div>
          </template>
          <template v-else>
            <div class="meunChildBox" @click.stop="displayHide(true)">
              <i class="el-icon-arrow-down arrow-down1" :style="{ color: colorFlag % 2 == 1 ? 'red' : '#fff' }"></i>
              <i class="el-icon-arrow-down arrow-down2" :style="{ color: colorFlag % 2 == 1 ? 'red' : '#fff' }"></i>
            </div>
          </template>
        </div>
        <p class="arrow-left">
          <i class="el-icon-more" :class="{ arrowActive: arrowFlag == 'left' }" @click.stop="timeUpdate('left')"></i>
        </p>
        <ul class="timeValueBox">
          <li v-for="(item, index) in timeValue" :key="index" :class="{ timeActive: timeCurTime == item }" @click.stop="handleTime(item, $event)">
            {{ item }}
          </li>
        </ul>
        <p class="arrow-right">
          <i class="el-icon-more" :class="{ arrowActive: arrowFlag == 'right' }" @click.stop="timeUpdate('right')"></i>
        </p>
      </div>
    </div>
    <!-- 时间选择框组件 -->
    <div class="timeCompenent" v-if="timeCompenentFlag" :style="{ left: x, top: y }">
      <el-date-picker v-model="pickerValue" type="date" @change="changeDetermineTime" placeholder="选择日期" :popper-class="getBackground" :picker-options="pickerOptions0"></el-date-picker>
    </div>
    <!-- 表格组件 -->
    <div class="tebleBox animate__animated" v-if="!menuFlag">
      <div class="table_childBox">
        <div class="tableoOut" ref="tableoOut">
          <div class="tableHeade">
            <li class="heade-item">卫星名称</li>
            <li class="heade-item">所属国家</li>
            <li class="heade-item">发射日期</li>
            <li class="heade-item">类型</li>
            <li class="heade-item">发射地址</li>
            <li class="heade-item">国际代号</li>
          </div>
          <div class="tableBodyBox" ref="tableBox" :style="{ height: tableHei }">
            <div class="tableInner" ref="tableInner">
              <div class="tableBlack" v-for="item in tableData" :key="item">
                <div class="body-item">{{ item.object_name }}</div>
                <div class="body-item">{{ item.chineseName }}</div>
                <div class="body-item">{{ item.launch_date }}</div>
                <div class="body-item">{{ item.object_TYPE }}</div>
                <div class="body-item">{{ item.siteName }}</div>
                <div class="body-item">{{ item.object_ID }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <ul class="tableHeade">
                    <li class="heade-item">卫星名称</li>
                    <li class="heade-item">所属国家</li>
                    <li class="heade-item">发射日期</li>
                    <li class="heade-item">类型</li>
                    <li class="heade-item">发射地址</li>
                    <li class="heade-item">国际代号</li>
                </ul>
                <div class="tableBodyBox">
                    <virtual-scroll :source-data-list="tableData" :one-data-height="34" :scroll-last-flag="true"
                        :scroll-flag="true" @scroll-last="getTimeData" @scroll="scrollHandler" ref="vscroll">
                        <template v-slot:default="slotProps">
                            <div class="body-item">{{ slotProps.row.object_name }}</div>
                            <div class="body-item">{{ slotProps.row.chineseName }}</div>
                            <div class="body-item">{{ slotProps.row.launch_date }}</div>
                            <div class="body-item">{{ slotProps.row.object_TYPE }}</div>
                            <div class="body-item">{{ slotProps.row.siteName }}</div>
                            <div class="body-item">{{ slotProps.row.object_ID }}</div>
                        </template>
                    </virtual-scroll>
                    <div class="tableDataInfoBox" v-if="tableData.length == 0">
                        暂无数据
                    </div>
                </div> -->
      </div>
    </div>
    <!-- loading -->
    <div class="loading" v-if="loadingFlag">
      <p class="loadingTitle">&nbsp;&nbsp;&nbsp;&nbsp;数据加载中.....</p>
      <div class="spinner">
        <div class="spinner-container container1">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container2">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container3">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
      </div>
    </div>
    <div class="entityInof" v-show="ISVIEWER">
      <div class="InofHead">{{ infoData.objectName ? infoData.objectName : '' }}</div>
      <div class="InofCesium" id="InofCesium"></div>
      <div class="InofCont">
        <p>国家地区：{{ infoData.region ? infoData.region : '' }}</p>
        <p>发射日期：{{ infoData.launch_DATE ? infoData.launch_DATE : '' }}</p>
        <p>近地点：{{ infoData.periapsis ? infoData.periapsis : 0 }}km</p>
        <p>远地点：{{ infoData.apoapsis ? infoData.apoapsis : 0 }}km</p>
        <p>半长轴：{{ infoData.a ? (infoData.a / 1000).toFixed(6) : 0 }}km</p>
        <p>偏心率：{{ infoData.e ? infoData.e : 0 }}</p>
        <p>轨道倾角：{{ infoData.i ? infoData.i.toFixed(6) : 0 }}°</p>
        <p>升交点赤经：{{ infoData.o ? infoData.o.toFixed(6) : 0 }}°</p>
        <p>近地点幅角：{{ infoData.w ? infoData.w.toFixed(6) : 0 }}°</p>
        <p>平近点角：{{ infoData.m ? infoData.m.toFixed(6) : 0 }}°</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as turf from "@turf/turf";
import axios from "axios";
import imageUrl from "../assets/yejiandiqiu.png";
import imageUrl2 from "../assets/mercator-tex.jpg";
import { SatelliteEntityWrapper } from "./SatelliteEntityWrapper";
import { loadVoLteResourceList } from "@/api/loadScript"
import { getCountry } from "@/api/request";

export default {
  data () {
    return {
      visible: false,
      ISVIEWER: false,
      infoData: {},
      countriesVal: undefined, // 卫星名称参数
      countriesOption: [], //国家字典表数据
      setiliteOption: [
        {
          chineseName: "全部",
          code: 0,
          englishName: "全部"
        },
        {
          chineseName: "低轨",
          code: 1,
          englishName: "低轨"
        },
        {
          chineseName: "中轨",
          code: 2,
          englishName: "中轨"
        },
        {
          chineseName: "高轨",
          code: 3,
          englishName: "高轨"
        },
      ], //轨道字典表数据
      pickerOptions0: {
        disabledDate (time) {
          return (
            time.getTime() > new Date(DateTime).getTime()
          )
        },
      },
      imgData: [
        // "../assets/testBlue.png",
        // "../assets/testGrey.png",
        // "../assets/testRed.png",
        "../assets/red.png",
        "../assets/blue.png",
        "../assets/green.png",
        "../assets/yellow.png",
        // "../assets/grey.png"
        // "../assets/orange.png",
      ], // 目标渲染图片路径
      colorData: ["RED", "BLUE", "GRAY"],
      imgCurIndex: 0, // 目标渲染索引
      explicitAndImplicitFlag: false, // 页面元素显隐标识
      searchList: [], //搜索数据集合
      searchFilterList: [], //搜索过滤数据集合
      satelliteResultData: [], // 太空目标渲染数据
      searchValue: "", // 搜索框值
      searchInfoFlag: false, // 搜索信息集合显隐标识
      typeList: [
        {
          name: "太空卫星",
          switchFlag: true,
          srcUrl: 1,
          Num: 0,
          srcName: 'PAYLOAD',
          background: `linear-gradient(294deg, rgba(255,255,255,0.3701855742296919) 0%, rgba(19,252,1,1) 47%, rgba(255,255,255,0.4542191876750701) 100%)`,
          boxShadow: `0 0 10px 4px #00ff59`,
        },
        {
          name: "太空碎片",
          switchFlag: true,
          srcUrl: 2,
          Num: 0,
          srcName: 'DEBRIS',
          background: `linear-gradient(294deg, rgba(255,255,255,0.3701855742296919) 0%, rgba(252,13,1,1) 47%, rgba(255,255,255,0.4542191876750701) 100%)`
          , boxShadow: `0 0 10px 4px #ff0c00`
        },
        {
          name: "火箭部件",
          switchFlag: true,
          srcUrl: 3,
          Num: 0,
          srcName: 'ROCKETBODY',
          background: `linear-gradient(294deg, rgba(255,255,255,0.3701855742296919) 0%, rgba(1,56,252,1) 47%, rgba(255,255,255,0.4542191876750701) 100%)`
          , boxShadow: `0 0 10px 4px #4000ff`
        },
        {
          name: "待定目标",
          switchFlag: true,
          srcUrl: 4,
          Num: 0,
          srcName: 'TBA',
          background: `linear-gradient(294deg, rgba(255,255,255,0.3701855742296919) 0%, rgba(119,129,131,1) 47%, rgba(255,255,255,0.4542191876750701) 100%)`
          , boxShadow: `0 0 10px 4px #828086`
        },
        {
          name: "未知目标",
          switchFlag: true,
          srcUrl: 5,
          Num: 0,
          srcName: 'UNKNOWN',
          background: `linear-gradient(294deg, rgba(255,255,255,0.3701855742296919) 0%, rgba(255,158,0,1) 47%, rgba(255,255,255,0.4542191876750701) 100%)`
          , boxShadow: `0 0 10px 4px #ff9e00`
        },
      ],
      typeBoxFlag: null, // 显示icon对应的功能
      functionList: [
        {
          name: "目标名称",
          switchFlag: false,
        },
        {
          name: "目标轨道",
          switchFlag: false,
        },
        {
          name: "预警检测",
          switchFlag: false,
        },
        {
          name: "晨昏线",
          switchFlag: false,
        },
        {
          name: "大气层",
          switchFlag: false,
        },
        // {
        //   name: "帧数(FPS)",
        //   switchFlag: false
        // },
        // {
        //   name: "雾气效果",
        //   switchFlag: false
        // }
      ], // 设置数据
      perspectiveSetList: [
        {
          name: "3D",
          switchFlag: true,
        },
        // {
        //     name: "2.5D",
        //     switchFlag: false,
        // },
        {
          name: "2D",
          switchFlag: false,
        },
      ], // 视角数据
      loadingFlag: true, // 初始化loading标识
      rowInfoData: [],
      satellites: [],
      enabledComponents: ["Point", "Label", "Orbit"],
      enabledTags: [],
      stopFlag: true, // 播放暂停开始标识
      sliderValue: 1, // 倍数拖拽默认值
      currentTimeValue: "2021/12/27 10:12:01", // 播放当前时间
      modelCurUrl: "",
      pengzhuangyujingFlag: false,
      starLinksData: [], // 碰撞预警starlinks数据
      pickId: "",
      imageUrl: imageUrl,
      imageUrl2: imageUrl2,
      timeLineFlag: true,
      timeValue: [],
      timeCurTime: "",
      arrowFlag: "",
      timeCompenentFlag: false,
      x: "",
      y: "",
      pickerValue: "",
      spaceTargetDataUrl: "",
      curTime: "2050-01-01", //接口请求时间
      year: '',
      currentYear: '',
      dateType: 1, // 接口类型
      dateName: '',
      orbitType: 0,
      region: '',
      tableData: [],
      menuFlag: true, // 控制表格显隐标识
      colorFlag: 0,
      timeout: null,
      searchLoadingFlag: false,
      workerArr: [], //线程数据组
      selfNum: 0, //线程数j进度
      selfInter: null, //线程数定时器
      typeChildActive: -1, //选中目标类型
      TableHei: "auto",
      Timer: null,
      Size: 0,
      isView: false
    };
  },
  watch: {
    satelliteResultData (val) {
      // console.dir(val.splice(0, 10));
      // if (viewer.entities && viewer.entities._entities._array.length) {
      //   var starData = viewer.entities._entities._array
      //   starData.map(item => {
      //     console.log(item)
      //     var entityModel = {
      //       uri: './models/demo4/scene.gltf',
      //       scale: 1000,
      //       // minimumPixelSize: 128,
      //       // maximumScale: 20000,
      //     }
      //     item.model = entityModel
      //   })
      // }
      this.typeChildActive = -1;
      this.ISVIEWER = false
      window.satelliteType = []
      if (val && val.length) {
        val.map(item => {
          var type = item.objectType.replace(' ', '')
          if (!window.satelliteType.includes(type)) {
            window.satelliteType.push(type)
            window[type] = []
            window[type].push(item)
          } else {
            window[type].push(item)
          }
        })
      }
      this.typeList.forEach(Item => {
        Item.Num = 0
        window.satelliteType.forEach(satelliteItem => {
          if (Item.srcName == satelliteItem) {
            Item.Num = window[satelliteItem].length
          }
        });
      })
      this.titleNum = 0
      this.typeList.forEach(Item => {
        this.titleNum += Item.Num
      })
    },
    region (newVal) {
      this.loadingFlag = true
      this.darwTarget2();
      this.getTimeData();


    },
    orbitType (newVal) {
      this.loadingFlag = true
      this.darwTarget2();
      this.getTimeData();

    },
    // // 模糊搜索
    searchValue (newVal) {
      if (newVal) {
        this.searchInfoFlag = true;
      } else {
        this.searchInfoFlag = false;
      }
      if (newVal == "") return;
    },
    rowInfoData () {
      if (entity2) entity2._model._uri._value = this.modelCurUrl;
    },
    pengzhuangyujingFlag (newVal) {
      if (newVal) {
        var provider = new Cesium.SingleTileImageryProvider({
          url: this.imageUrl2,
        });
        const layers = viewer.scene.imageryLayers;
        layers.removeAll();
        layers.addImageryProvider(provider);
        this.timeLineFlag = false;
        this.timeCompenentFlag = false;
      } else {
        this.timeLineFlag = true;
        const layers = viewer.scene.imageryLayers;
        var provider2 = new Cesium.SingleTileImageryProvider({
          url: this.imageUrl,
          rectangle: new Cesium.Rectangle.fromDegrees(-180, -85, 180, 85),
        });
        layers.removeAll();
        layers.addImageryProvider(provider2);
      }
    },
    explicitAndImplicitFlag (newVal) {
      if (newVal) {
        this.searchInfoFlag = !newVal;
      }
    },
  },
  computed: {
    filPersons () {
      return this.searchFilterList.filter((p) => {//返回过滤后的数组
        var str = p.objectName + "_" + p.norad_cat_id
        return str.indexOf(this.searchValue) !== -1
      })//filter是过滤函数去除了不包含关键字的情况
    },
    getBackground () {
      switch (this.menuFlag) {
        case true:
          return "defaultTop";
          break;
        case false:
          return "defaultBottom";
          break;
      }
    },
  },
  mounted () {
    // let token = sessionStorage.getItem('token')
    // if (!token) {
    //   token = this.$route.query.token
    //   if (!token) {
    //     this.isView = true
    //     this.$alert('您当前不具备访问权限，请向上级获取账户信息登陆后访问', '提示', {
    //       confirmButtonText: '确定',
    //       callback: () => {
    //         if (window.location.hostname == "39.107.241.137") {
    //           window.location.href = `http://39.107.241.137:28891/hall/#/login?referrer=1`
    //         } else {
    //           window.location.href = `http://192.168.2.145:7103/hall/#/login?referrer=1`
    //         }
    //       }
    //     });
    //   } else {
    //     this.verification(token)
    //   }
    // } else {
    //   this.verification(token)
    // }
    that = this
    this.initCesium()
    this.getTable();
    this.curTime = DateTime
    // loadVoLteResourceList(["SpecialEffects/cesiumInit.js"])
    // sessionStorage.removeItem('token')
  },
  methods: {
    handVisible () {
      this.typeBoxFlag = null;
      this.visible = !this.visible
    },
    verification (val) {
      function decrypt (word, keyStr) {
        let key = CryptoJS.enc.Utf8.parse(keyStr)
        let decrypt = CryptoJS.AES.decrypt(word, key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.ZeroPadding,
          },
        )
        let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString();
        return decString
      }
      let Jtext = decrypt(decodeBase64URLSafe(val), "KAIYUNLIANHE")
      if (Jtext) {
        var data = Jtext.split('-')
        if (data[2] == new Date().getDate()) {
          sessionStorage.setItem('token', val)
        } else {
          this.isView = true
          this.$alert('您当前不具备访问权限，请向上级获取账户信息登陆后访问', '提示', {
            confirmButtonText: '确定',
            callback: () => {
              if (window.location.hostname == "39.107.241.137") {
                window.location.href = `http://39.107.241.137:28891/hall/#/login?referrer=1`
              } else {
                window.location.href = `http://192.168.2.145:7103/hall/#/login?referrer=1`
              }
            }
          });
        }
      }
    },
    initCesium () {
      this.initStarLinkData();
      var newYear = new Date()
      this.year = newYear.getFullYear(); // 得到年份
      this.timeCurTime = this.year
      this.currentYear = this.year
      this.timeValue = this.coputedTime();
      // 目标检索数据
      setInterval(() => {
        this.colorFlag += 1;
      }, 1000);
      // this.initSatelliteData();
      getCountry()
        .then((res) => {
          if (res.code == 200) {
            this.countriesOption = res.data;
          }
        })
        .catch((error) => { });
      InitCesium();
    },
    getTable () {
      const outHei = this.$refs.tableoOut.clientHeight - 60;
      this.Size = Math.floor(outHei / 50);
      this.TableHei = this.Size * 50 + "px";
      this.scrolls();
    },
    stepScroll () {
      const step = 50;
      let num = 0;
      const tableBox = this.$refs.tableBox;
      const stepTime = setInterval(function () {
        num += 2;
        if (num > step) {
          num = 0;
          clearInterval(stepTime);
        } else {
          tableBox.scrollTop += 2;
        }
      }, 20);
    },
    scrolls () {
      const that = this;
      const tableBox = this.$refs.tableBox;
      const tableInner = this.$refs.tableInner;
      clearInterval(this.Timer);
      this.Timer = setInterval(function () {
        if (tableBox.scrollTop === tableInner.scrollHeight) {
          tableBox.scrollTop = 0;
        }
        that.stepScroll();
      }, 2000);
    },

    //选择隐藏类型
    handelChild (val) {
      this.ISVIEWER = false
      if (this.typeChildActive != val.srcUrl) {
        this.typeChildActive = val.srcUrl;
        if (window.satelliteType.includes(val.srcName)) {
          if (Creatunion) {
            if (window[val.srcName] && window[val.srcName].length) {
              if (window[val.srcName][0].time) {
                var nowDate = Cesium.JulianDate.fromIso8601(window[val.srcName][0].time);
                var clockStart = nowDate;
                var clockStop = Cesium.JulianDate.addHours(
                  nowDate,
                  24 * 7,
                  new Cesium.JulianDate()
                );
                viewer.clock.currentTime = nowDate;
                viewer.clock.startTime = clockStart;
                viewer.clock.stopTime = clockStop;
              }
              Creatunion.reloadPoint(window[val.srcName]);
            }
          }

        } else {
          // if (this.satelliteResultData && this.satelliteResultData.length) {
          // if (this.satelliteResultData[0].time) {
          //     var nowDate = Cesium.JulianDate.fromIso8601(this.satelliteResultData[0].time);
          //     var clockStart = nowDate;
          //     var clockStop = Cesium.JulianDate.addHours(
          //         nowDate,
          //         24 * 7,
          //         new Cesium.JulianDate()
          //     );
          //     viewer.clock.currentTime = nowDate;
          //     viewer.clock.startTime = clockStart;
          //     viewer.clock.stopTime = clockStop;
          // }
          // if (Creatunion) {
          // Creatunion.reloadPoint(this.satelliteResultData);
          // }
          // }
          if (Creatunion) {
            Creatunion.reloadPoint([]);
          }

        }
      } else {
        this.typeChildActive = -1;
        if (this.satelliteResultData && this.satelliteResultData.length) {
          if (this.satelliteResultData[0].time) {
            var nowDate = Cesium.JulianDate.fromIso8601(this.satelliteResultData[0].time);
            var clockStart = nowDate;
            var clockStop = Cesium.JulianDate.addHours(
              nowDate,
              24 * 7,
              new Cesium.JulianDate()
            );
            viewer.clock.currentTime = nowDate;
            viewer.clock.startTime = clockStart;
            viewer.clock.stopTime = clockStop;
          }
          if (Creatunion) {
            Creatunion.reloadPoint(this.satelliteResultData);
          }
        }
      }
    },
    // 获取碰撞starLink数据
    initStarLinkData () {
      starLinksTestData.forEach((item) => {
        this.starLinksData.push(item.name);
        var cur = item.name + "\n" + item.tle1 + "\n" + item.tle2;
        this.addFromTle(cur, ["test"]);
      });
    },
    // ----------------------------------------------------------------------------------------------------------
    // 获取卫星列表数据
    initSatelliteData () {
      axios
        .get(
          `${AxiosApi}/orbitdata/getSpacecraftName?dateTimeStr=${DateTime} 00:00:00.000&dateType=${this.dateType}&name=`
          // `${AxiosApi}/orbitdata/getSpaceTargetVagueByObjectName?name=${val}&dateTimeStr=${this.curTime}T00:00:00&dateType=${this.dateType}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.code == 200 && res.data.data.length > 0) {
            this.searchLoadingFlag = false;
            this.searchFilterList = res.data.data;
          } else {
            this.$message.warning("暂无数据");
            this.searchLoadingFlag = false;
          }
        })
        .catch((error) => {
          this.searchLoadingFlag = false;
          this.$message.error("初始化获取卫星列表接口调用失败!");
        });
    },
    // ----------------------------------------------------------------------------------------------------------
    // 解析TLE件第一步
    addFromTleUrl (url, tags) {
      axios
        .get(url)
        .then((response) => {
          let data = response.data;
          const lines = data.split(/\r?\n/);
          for (let i = 3; i < lines.length; i + 3) {
            const tle = lines.splice(i - 3, i).join("\n");
            this.addFromTle(tle, tags);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 解析TLE第二步
    addFromTle (tle, tags) {
      const sat = new SatelliteEntityWrapper(viewer, tle, tags);
      this.add(sat);
    },
    // 解析TLE第三步
    add (newSat) {
      const existingSat = this.satellites.find(
        (sat) =>
          sat.props.satnum === newSat.props.satnum &&
          sat.props.name === newSat.props.name
      );
      if (existingSat) {
        existingSat.props.addTags(newSat.props.tags);
        if (newSat.props.tags.some((tag) => this.enabledTags.includes(tag))) {
          existingSat.show(this.enabledComponents);
        }
        return;
      }
      this.satellites.push(newSat);
      if (newSat.props.tags.some((tag) => this.enabledTags.includes(tag))) {
        newSat.show(this.enabledComponents);
        if (this.pendingTrackedSatellite === newSat.props.name) {
          this.trackedSatellite = newSat.props.name;
        }
      }
    },
    // 控制TLE目标渲染
    enabledSatellitesByName (sats) {
      this.satellites.forEach((sat) => {
        if (sats.includes(sat.props.name)) {
          sat.show(this.enabledComponents);
        } else {
          sat.hide();
        }
      });
    },
    // -------------------------------- 播放器 ------------------------------------------
    // slide加速
    sliderChange () {
      viewer.clock.multiplier = this.sliderValue;
    },
    // 快进 暂停 快退
    iconChnge (val) {
      switch (val) {
        case "left":
          viewer.clock.multiplier = 1;
          this.sliderValue = 1;
          break;
        case "center":
          this.stopFlag = !this.stopFlag;
          viewer.clock.shouldAnimate = this.stopFlag;
          break;
        case "right":
          // var data = viewer.entities._entities._array
          // console.dir(data, '-----data')
          // data.map(item => {
          //     item['model'] = {
          //         uri: './models/SAR卫星.gltf',
          //         minimumPixelSize: 20
          //     }
          // })
          switch (this.sliderValue) {
            case 300:
              this.sliderValue = 1800;
              viewer.clock.multiplier = 1800;
              break;
            case 1800:
              this.sliderValue = 3600;
              viewer.clock.multiplier = 3600;
              break;
            case 3600:
              this.sliderValue = 6848;
              viewer.clock.multiplier = 6848;
              break;
            default:
              this.sliderValue = 300;
              viewer.clock.multiplier = 300;
              break;
          }
          break;
      }
    },
    // 渲染太空目标2
    darwTarget2 () {
      var that = this;
      axios
        .get(
          // `${AxiosApi}/orbitdata/getKeplerListForCG?endTime=${this.curTime} 00:00:00.000&dateType=${this.dateType}&name=${this.dateName}&orbitType=${this.orbitType ? this.orbitType : 0}&region=${this.region}`
          `${AxiosApi}/orbitdata/getKeplerList?endTime=${this.curTime} 00:00:00.000&dateType=${this.dateType}&name=${this.dateName}&orbitType=${this.orbitType ? this.orbitType : 0}&region=${this.region}`
        )
        .then((res) => {
          that.satelliteResultData = res.data.data;
          that.searchFilterList = res.data.data;
          that.loadingFlag = false;
          if (!that.satelliteResultData.length) {
            that.$message.info("暂无数据");
            Creatunion.reloadPoint(that.satelliteResultData);
            return;
          }
          if (that.satelliteResultData && that.satelliteResultData.length) {
            if (that.satelliteResultData[0].time) {
              var nowDate = Cesium.JulianDate.fromIso8601(that.satelliteResultData[0].time);
              var clockStart = nowDate;
              var clockStop = Cesium.JulianDate.addHours(
                nowDate,
                24 * 7,
                new Cesium.JulianDate()
              );
              viewer.clock.currentTime = nowDate;
              viewer.clock.startTime = clockStart;
              viewer.clock.stopTime = clockStop;
            }
            if (Creatunion) {
              Creatunion.reloadPoint(that.satelliteResultData);
            }
          }

        })
        .catch((error) => {
          console.log(error);
          this.loadingFlag = false;
          this.$message.error("初始化接口调用失败!");
        });
    },
    // -------------------------------- 页面功能元素盒子 头部按钮导航 ----------------------------
    // 初始相机位置
    camreaPosition () {
      viewer.camera.flyTo({
        destination: Cesium.Rectangle.fromDegrees(95.0, -20.0, 120.0, 90.0),
      });
    },
    // 视角切换
    handlePerspective (cur) {
      this.perspectiveSetList.forEach((item) => {
        if (cur.name != item.name) {
          item.switchFlag = false;
        }
      });
      switch (cur.name) {
        case "3D":
          // viewer.scene.mode = Cesium.SceneMode.SCENE3D;
          viewer.scene.morphTo3D(1); //三维
          break;
        case "2.5D":
          viewer.scene.morphToColumbusView(1); //哥伦布视图
          break;
        case "2D":
          // viewer.scene.mode = Cesium.SceneMode.SCENE2D;
          viewer.scene.morphTo2D(1); //二维
          break;
        default:
          break;
      }

    },
    // 目标点击跳转相机
    breakCarame (data) {
      let entities = null;
      this.satellites.forEach((sat) => {
        if (data.includes(sat.props.name)) {
          entities = sat;
        }
      });
      setTimeout(() => {
        if (entities && entities.entities) {
          viewer.trackedEntity = entities.entities.Point;
        }
        this.modelCurUrl = "models/电侦卫星.gltf";
        if (this.rowInfoData.length == 0) {
          this.rowInfoData.push({
            object_name: "xxxx",
            chineseName: "xxxx",
            launch_date: "xxxx",
            object_TYPE: "xxxx",
            siteName: "xxxx",
          });
        }
      }, 50);
    },
    // 目标列表点击跳转
    nweBreakCarame (item) {
      // 点击目标查出目标信息
      var Entity = getEntity(item.objectName)
      viewer.selectedEntity = Entity
    },
    // 移入事件
    showBox (val) {
      this.typeBoxFlag = val;
      this.visible = false
    },
    // 设置事件
    handleFunction (cur) {
      switch (cur.name) {
        case "预警检测":
          this.pengzhuangyujingFlag = cur.switchFlag;
          if (!cur.switchFlag) {
            viewer.entities.removeAll();
            viewer.camera.flyTo({
              destination: Cesium.Rectangle.fromDegrees(
                95.0,
                -20.0,
                120.0,
                90.0
              ),
            });
            viewer.clock.multiplier = 1;
            return;
          }
          // "2021-035B",
          this.enabledSatellitesByName(
            ["2021-035A", "STARLINK-1095", "STARLINK-24"].concat(
              this.starLinksData
            )
          );
          this.modelCurUrl = "models/电侦卫星.gltf";
          this.breakCarame(["2021-035A"]);
          break;
        case "晨昏线":
          viewer.scene.globe.enableLighting = cur.switchFlag;
          break;
        case "大气层":
          viewer.scene.skyAtmosphere.show = cur.switchFlag;
          break;
        case "帧数(FPS)":
          viewer.scene.debugShowFramesPerSecond = cur.switchFlag;
          break;
        case "雾气效果":
          viewer.scene.fog.enabled = cur.switchFlag;
          break;
        default:
          break;
      }
    },
    // -------------------------------- table卫星信息列表 ------------------------------------------
    // 连接跳转
    breakProject () {
      if (this.pickId == 48274) {
        window.open(
          `http://192.168.2.163:31004/#/navigatioCollection?id=${this.pickId}`
        );
      } else {
        this.$message.info("暂无数据");
      }
    },
    /**
     * 滚动事件处理
     */
    scrollHandler (val) {
      this.isScrollShow = val > 1000 ? true : false;
    }, // 获取时间轴时间对应的数据
    getTimeData (flag) {
      axios
        .get(
          // `${AxiosApi}/orbitdata/getSpaceTargetLaunchDetailForCG?endTime=${this.curTime}T00:00:00&dateType=${this.dateType}&name=${this.dateName}&orbitType=${this.orbitType ? this.orbitType : 0}&region=${this.region}`
          `${AxiosApi}/orbitdata/getSpaceTargetLaunchDetail?endTime=${this.curTime}T00:00:00&dateType=${this.dateType}&name=${this.dateName}&orbitType=${this.orbitType ? this.orbitType : 0}&region=${this.region}`
        )
        .then((res) => {
          let result = res.data;
          if (result.data.length > 0) {
            this.tableData = result.data;
          } else {
            this.tableData = [];
          }
        });
    },
    // -------------------------------- 时间轴 ------------------------------------------
    // 计算时间轴年
    coputedTime (val) {
      let result = [];
      let start = val ? val : this.currentYear,
        endTime = 1957;
      for (let i = start; i >= endTime && result.length < 9; i--) {
        result.push(i);
      }
      if (result.length < 9) {
        let aa = result[0];
        for (let i = 1; i < 9 && result.length < 9; i++) {
          result.unshift(aa + i);
        }
      }
      return result.reverse();
    }, // 时间轴左右点击事件
    timeUpdate (flag, e) {
      this.arrowFlag = flag;
      this.timeCompenentFlag = false;
      if (flag == "left") {
        let end = this.timeValue[0];
        this.timeValue = this.coputedTime(end);
      } else {
        let num = this.timeValue[this.timeValue.length - 1] + 27;
        if (num > this.currentYear) {
          num = this.currentYear;
        }
        this.timeValue = this.coputedTime(num);
      }
    },
    // 时间轴时间点击后，计算时间组件位置
    handleTime (val, e) {
      this.timeCompenentFlag = true;
      this.updateTime(val);
      this.x = e.clientX - 100 + "px";
      this.y = e.clientY - 80 + "px";
      this.timeCurTime = val;
    },
    // 时间轴点击赋值时间组件年份
    updateTime (val) {
      this.year = val
      var now = new Date(`${val}-01-01 00:00:00`);
      var year = now.getFullYear(); // 得到年份
      var month = now.getMonth(); // 得到月份 
      var date = now.getDate(); // 得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this, "pickerValue", defaultDate);
      this.curTime = `${val + 1}-01-01`;
      this.dateType = 1;
      this.loadingFlag = true;
      this.darwTarget2();
      this.getTimeData();
    },
    // 时间戳转换及确定事件
    changeDetermineTime (val) {
      let that = this;
      function myFormatDate (dd) {
        var now = new Date(dd);
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        if (month > 1) {
          that.dateType = 2;
        }
        month = month < 10 ? "0" + month : month;
        if (now.getDate() > 1) {
          that.dateType = 3;
        }
        var date = now.getDate() < 10 ? "0" + now.getDate() : now.getDate();
        // if(parseFloat(date)>01){that.dateType=3}
        var hour = now.getHours() < 10 ? "0" + now.getHours() : now.getHours();
        var minute =
          now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
        var second =
          now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
        return (
          year + "-" + month + "-" + date
          // " "
          // hour +
          // ":" +
          // minute +
          // ":" +
          // second
        );
      }
      this.curTime = myFormatDate(val);
      this.loadingFlag = true;
      this.darwTarget2();
      this.getTimeData();
    },
    // 时间轴 控制表格显隐事件
    displayHide (val) {
      this.timeCompenentFlag = false;
      this.menuFlag = val;
    },
  },
};
</script>
<style lang='less' type="text/less">
@import "./css/bottom.less";
@import "./css/heade.less";
</style>
<style>
.el-message-box {
  background: none !important;
  border: none !important;
}
.el-message-box__message,
.el-message-box__title {
  color: #fff !important;
}
.el-message-box__headerbtn {
  display: none !important;
}

.el-date-table td.disabled div {
  background-color: #f5f7fa26 !important;
}
</style>
<style lang='less'>
#cesiumBox {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  color: #000;

  #cesiumContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;

    .cesium-viewer {
      width: 100%;
      height: 100%;

      .cesium-viewer-cesiumWidgetContainer {
        width: 100%;
        height: 100%;

        .cesium-widget {
          width: 100%;
          height: 100%;

          canvas {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.typeChildActive {
  background-color: red !important;
}

.cesium-viewer-timelineContainer {
  display: none;
}

.cesium-viewer-animationContainer {
  display: none;
}

.tableBlack {
  width: 100%;
  height: 100%;
  display: flex;
  overflow-y: auto;

  .body-item {
    width: 20%;
    text-align: center;
  }
}

.el-slider__runway {
  height: 0.02rem;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 10%,
    rgba(255, 255, 255, 0.3) 20%,
    rgba(255, 255, 255, 0.4) 30%,
    rgba(255, 255, 255, 0.5) 40%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0.4) 70%,
    rgba(255, 255, 255, 0.3) 80%,
    rgba(0, 0, 0, 0) 90%,
    rgba(0, 0, 0, 0) 100%
  );
}

.el-slider__bar {
  height: 0px;
}

.el-slider__button-wrapper {
  top: -0.17rem;
}

.el-slider__button {
  border: 3px solid #fff;
  background-color: #409eff;
}

.ant-input {
  border: 0px !important;
  border-radius: 0px !important;
  background: rgba(0, 0, 0, 0) !important;
  border-bottom: 1px solid #eee !important;
  color: #fff !important;
}

.ant-input-search-icon {
  color: #fff !important;
}

.ant-switch {
  width: 60px !important;
  background: #5c5968 !important;
}

.ant-switch-checked {
  background: #1890ff !important;
}

// 下拉框样式覆盖
.el-select {
  color: #fff !important;
  border: 0px !important;
  border-radius: 0px !important;
  background: rgba(0, 0, 0, 0) !important;

  .el-input__inner {
    background-color: transparent !important;
    border-radius: 0 !important;
    color: #fff !important;
    border: none !important;
    border-bottom: 1px solid #eee !important;
    height: 32px !important;
    line-height: 32px !important;
  }
}

.el-scrollbar {
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.el-select-dropdown__item {
  color: #fff;
}

.el-select-dropdown__item:hover {
  background: #aa2727;
}

.el-select-dropdown__item.selected {
  background: #aa2727;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #aa2727;
}

.timeCompenent .el-input__inner {
  background-color: #00000063;
  border: 1px solid #ffffff61;
}

.el-picker-panel {
  border: 1px solid;
}

.defaultBottom {
  top: 28% !important;

  .popper__arrow {
    display: none;
  }
}
</style>